import { render, staticRenderFns } from "./DeviceModel.vue?vue&type=template&id=36b4179f&scoped=true"
import script from "./DeviceModel.vue?vue&type=script&lang=js"
export * from "./DeviceModel.vue?vue&type=script&lang=js"
import style0 from "./DeviceModel.vue?vue&type=style&index=0&id=36b4179f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4179f",
  null
  
)

export default component.exports